import { IconGearSix } from '@vtex/shoreline'
import { t } from 'i18next'

import styles from '../styles.module.css'

interface MarketplaceRechargeStatusProps {
  hasAutoRecharge: boolean
  onOpenSettings: () => void
}

export const MarketplaceRechargeStatus = ({
  hasAutoRecharge,
  onOpenSettings
}: Readonly<MarketplaceRechargeStatusProps>) => {
  const label = hasAutoRecharge
    ? t('rm:marketplace.rechargeAutomatically.active')
    : t('rm:marketplace.rechargeAutomatically.disabled')

  return (
    <div className={styles.statusRow}>
      <span
        className={
          hasAutoRecharge ? styles.statusActive : styles.statusInactive
        }
      >
        {label}
      </span>
      <button
        type="button"
        className={styles.gear}
        aria-label={t('rm:marketplace.sidepanel.title')}
        onClick={onOpenSettings}
      >
        <IconGearSix />
      </button>
    </div>
  )
}
